<p-splitter class="splitter" [style]="{ height: '100%' }" [panelSizes]="[30, 70]" [minSizes]="[20, 30]">

  <!-- Painel esquerdo: lista selecionável -->
  <ng-template #panel>
    <div class="painel-esquerdo">
      <h3 class="accent-color panel-title">{{ tituloEsquerda }}</h3>
      <div class="table-container">
        <p-table #dt [value]="itensEsquerda" responsiveLayout="scroll"
          [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
          selectionMode="single" [(selection)]="itemAtual" dataKey="id"
          (onRowSelect)="selecionar($event.data)"
          [globalFilterFields]="['label']">

          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="label">{{ labelColunaEsquerda }} <p-sortIcon field="label"></p-sortIcon></th>
            </tr>
          </ng-template>

          <ng-template #body let-item>
            <tr [pSelectableRow]="item" [ngClass]="{'row-selected': itemAtual?.id === item.id}">
              <td>{{ item.label }}</td>
            </tr>
          </ng-template>

        </p-table>
      </div>
    </div>
  </ng-template>

  <!-- Painel direito: checkboxes -->
  <ng-template #panel>
    <div class="painel-direito" [ngClass]="{'painel-direito--disabled': !itemAtual}">
      <div class="direita-header">
        <h3 class="accent-color panel-title">
          {{ itemAtual ? tituloDireita : tituloSemSelecao }}
        </h3>
        <div class="direita-acoes">
          @if (labelAcaoExtra) {
            <button mat-stroked-button (click)="acaoExtraClick.emit()">
              <mat-icon>add</mat-icon>
              {{ labelAcaoExtra }}
            </button>
          }
          <button mat-raised-button [disabled]="!itemAtual || salvando || salvarDesabilitado" (click)="salvar()">
            Salvar
          </button>
        </div>
      </div>

      @if (itemAtual) {
        <div class="itens-lista">
          <!-- Itens com grupo (ex: permissões por módulo): tabela com subtabela por grupo -->
          @if (agrupado) {
            <p-table
              [value]="gruposDireita"
              dataKey="grupo"
              [expandedRowKeys]="gruposExpandidos"
              class="grupos-table">
              <ng-template pTemplate="body" let-grupo let-expanded="expanded">
                <tr class="row-grupo">
                  <td class="coluna-toggler">
                    <p-button
                      type="button"
                      pRipple
                      [pRowToggler]="grupo"
                      [text]="true"
                      [rounded]="true"
                      [plain]="true"
                      [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                    </p-button>
                  </td>
                  <td class="celula-grupo">
                    <div class="item-row">
                      <p-checkbox
                        [binary]="true"
                        [ngModel]="isGrupoSelecionado(grupo)"
                        [indeterminate]="isGrupoIndeterminate(grupo)"
                        [disabled]="isGrupoDisabled(grupo)"
                        (ngModelChange)="toggleGrupo(grupo)">
                      </p-checkbox>
                      <span class="nome-grupo">{{ grupo.grupo }}</span>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="expandedrow" let-grupo>
                @for (item of grupo.itens; track item) {
                  <tr class="row-item">
                    <td class="coluna-toggler"></td>
                    <td>
                      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>
          } @else {
            @for (item of itensDireitaFiltrados; track item) {
              <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
            }
          }
        </div>
      } @else {
        <p class="sem-selecao-msg medium-emphasis">{{ mensagemSemSelecao }}</p>
      }

      <ng-template #itemTemplate let-item>
        <div class="item-row">
          <p-checkbox
            [binary]="true"
            [ngModel]="item.checado"
            (ngModelChange)="toggleItem.emit({ item: item, checked: $event })"
            [disabled]="!!item.bloqueado"
            [inputId]="'item-' + item.id">
          </p-checkbox>
          <label [for]="'item-' + item.id" class="item-label"
            [ngClass]="{'label-disabled': item.bloqueado}">
            <span class="item-nome">{{ item.label }}</span>
            @if (item.sublabel) {
              <span class="item-sublabel">{{ item.sublabel }}</span>
            }
            @if (item.bloqueado) {
              <span class="item-bloqueado-badge">
                <mat-icon class="badge-icon" [matTooltip]="item.tooltipBloqueado ?? ''">lock</mat-icon>
              </span>
            }
          </label>
        </div>
      </ng-template>

    </div>
  </ng-template>

</p-splitter>
